import { FluxType } from './FluxType';

export const FluxDisplayName: Record<keyof typeof FluxType, string> = {
  [FluxType.RPSI]: 'RPSI : Import du référentiel FO',
  [FluxType.ALIENATION_ETAT_BIENS]: 'DNID : Récupération des statuts de vente',
  [FluxType.ALIENATION_FOURRIERE]: 'DNID : Synchronisation des lieux de dépôt',
  [FluxType.ALIENATION_AUTORITE_FOURRIERE]:
    'DNID : Synchronisation des entités remettantes',
  [FluxType.ANTAI]: 'ANTAI : Récupération des statuts de notifications',
};
